import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const WTPSumpNumberTableDataAPI = createAsyncThunk("WTPSumpNumberTableData", async ({ data }) => {
    const {
        M_WTP_SumpID,
        M_WTP_PlantID,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_M_WTP_Sump_Select?M_WTP_SumpID=${M_WTP_SumpID ? M_WTP_SumpID : '0'}&M_WTP_PlantID=${M_WTP_PlantID ? M_WTP_PlantID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const WTPSumpNumberTableDataSlice = createSlice({
    name: "WTPSumpNumberTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPSumpNumberTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPSumpNumberTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WTPSumpNumberTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPSumpNumberTableDataReducer = WTPSumpNumberTableDataSlice.reducer


export const WTPSumpNumberPostDataAPI = createAsyncThunk("WTPSumpNumberPostData", async ({ data }) => {
    const {
        M_WTP_SumpID,
        M_WTP_PlantID,
        SumpNumber,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_WTP_SumpID", M_WTP_SumpID);
    formdata.append("M_WTP_PlantID", M_WTP_PlantID);
    formdata.append("SumpNumber", SumpNumber);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);


    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/Post_WEB_M_WTP_Sump_InsertUpdate`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const WTPSumpNumberPostDataSlice = createSlice({
    name: "WTPSumpNumberPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPSumpNumberPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPSumpNumberPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WTPSumpNumberPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WTPSumpNumberPostDataReducer = WTPSumpNumberPostDataSlice.reducer

// -----------------Delete API ---------------

export const WTPSumpNumberDeleteAPI = createAsyncThunk("WTPSumpNumberDelete", async ({ data }) => {
    const {
        M_WTP_SumpID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("M_WTP_SumpID", M_WTP_SumpID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/WEB_M_WTP_Sump_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const WTPSumpNumberDeleteSlice = createSlice({
    name: "WTPSumpNumberDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPSumpNumberDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(WTPSumpNumberDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(WTPSumpNumberDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WTPSumpNumberDeleteReducer = WTPSumpNumberDeleteSlice.reducer